const production = process.env.NODE_ENV === 'production' ? true : false


// 补全 url
const addUrl = url => {
  const headUrl = 'https://img.weilian.xin/'
  if (!url) return

  if (url && (url.includes('http') || url.includes('https'))) {
    return url
  } else {
    return headUrl + url
  }
}


// 获取url对应的参数名
const getUrlUserInfo = url => {
  if (!url) return undefined
  if (url.includes('sup')) {
    return 'sup'
  } else if (url.includes('mid')) {
    return 'mid'
  } else {
    return undefined
  }
}

// 页面跳转
const jump = (that, path, name) => {
  if (!path) return undefined
  $router.push({
    path,
    query: {
      [name]: that.$route.query[name]
    }
  })
}

const isMobile = () => {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}


export {
  production,
  addUrl,
  getUrlUserInfo,
  isMobile,
  jump
}



// WEBPACK FOOTER //
// ./src/common/common.js